module.exports = __webpack_public_path__ + "img/gift3-01-c07.5694bf73.png";